import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const S = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-serif text-2xl text-[#0A0A0A] mb-4">{title}</h2>
    <div className="text-base text-[#333] leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function CookiePolicy() {
  return (
    <div data-testid="cookie-page" className="min-h-screen bg-[#FAF9F6]">
      <header className="border-b border-[#E5E5E5]">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/"><img src="/logo.png" alt="Funghetto Roma" className="h-8 w-auto" /></Link>
          <Link to="/" data-testid="cookie-back-link" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#555] hover:text-[#6B1E33] transition-colors">
            <ArrowLeft size={14} /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-xs uppercase tracking-[0.3em] text-[#6B1E33] mb-4">Informativa ai sensi delle Linee guida del Garante Privacy</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#0A0A0A] mb-12">Cookie Policy</h1>

        <S title="Cosa sono i cookie">
          <p>
            I cookie sono piccoli file di testo che i siti salvano sul tuo dispositivo per
            funzionare correttamente o per raccogliere informazioni statistiche e di marketing.
          </p>
        </S>

        <S title="Quali cookie usa questo sito">
          <p>
            Questo sito utilizza <strong>esclusivamente cookie tecnici</strong>, necessari al suo
            funzionamento:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              <strong>Cookie di sessione dell'area riservata</strong> — permette al gestore del
              ristorante di accedere al pannello di amministrazione. Non riguarda i visitatori.
            </li>
            <li>
              <strong>Preferenza della lingua</strong> — ricorda se hai scelto italiano o inglese.
            </li>
          </ul>
          <p>
            Il sito <strong>non utilizza</strong> cookie di profilazione, cookie pubblicitari,
            cookie di analisi di terze parti né strumenti di tracciamento.
          </p>
        </S>

        <S title="Perché non compare il banner dei cookie">
          <p>
            Secondo le Linee guida del Garante per la protezione dei dati personali (2021), i siti
            che utilizzano solo cookie tecnici non sono tenuti a mostrare il banner del consenso,
            ma solo a fornire questa informativa.
          </p>
        </S>

        <S title="Come disattivare i cookie">
          <p>
            Puoi eliminare o bloccare i cookie dalle impostazioni del tuo browser
            (Safari, Chrome, Firefox). Bloccando i cookie tecnici alcune funzioni del sito
            potrebbero non funzionare correttamente.
          </p>
        </S>

        <S title="Titolare del trattamento">
          <p>
            <strong>Hosneara Begum</strong>, P.IVA <strong>18366311001</strong>, sede legale{" "}
            <strong>Via Urbano II 32, 00167 Roma (RM)</strong> —{" "}
            <a href="mailto:info@funghettoroma.it" className="text-[#6B1E33] underline">info@funghettoroma.it</a>.
          </p>
        </S>

        <p className="text-sm text-[#777] mt-16">Ultimo aggiornamento: ottobre 2026</p>
      </main>
    </div>
  );
}
